import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { SEARCH_TOFU_WORKSPACES_SUGGESTIONS } from "./gql";
import useTofuWorkspacesFiltersVariables from "./useFiltersVariables";

type UseSearchTofuWorkspacesSuggestionsProps = {
  stackId: string;
};

const useSearchTofuWorkspacesSuggestions = ({
  stackId,
}: UseSearchTofuWorkspacesSuggestionsProps) => {
  const { fullTextSearch } = useTofuWorkspacesFiltersVariables();

  const { data, previousData } = useQuery(SEARCH_TOFU_WORKSPACES_SUGGESTIONS, {
    variables: {
      input: {
        fields: null,
        fullTextSearch,
        predicates: [
          {
            field: "stack",
            constraint: {
              stringEquals: [stackId],
            },
          },
        ],
      },
    },
  });

  const filteredCount = useMemo(() => {
    return (
      data?.searchTofuWorkspacesSuggestions?.filteredCount ??
      previousData?.searchTofuWorkspacesSuggestions?.filteredCount ??
      0
    );
  }, [data, previousData]);

  return {
    filteredCount,
  };
};

export default useSearchTofuWorkspacesSuggestions;
